'use strict';exports.__esModule = true;var _requiredMapIcons;var INFO_WINDOW_CONTAINER_CLASSNAME = exports.INFO_WINDOW_CONTAINER_CLASSNAME = 'info_window_container_classname';
var PINS_SOURCE_ID = exports.PINS_SOURCE_ID = 'pins_source';
var PINS_LAYOUT_ID = exports.PINS_LAYOUT_ID = 'pins_layout';
var CITY_POLYGON_SOURCE_ID = exports.CITY_POLYGON_SOURCE_ID = 'city_polygon_source';
var CITY_POLYGON_LAYOUT_ID = exports.CITY_POLYGON_LAYOUT_ID = 'city_polygon_layout';
var CITY_BORDER_LAYOUT_ID = exports.CITY_BORDER_LAYOUT_ID = 'city_border_layout';
var STREET_SOURCE_ID = exports.STREET_SOURCE_ID = 'street_source';
var STREET_LAYOUT_ID = exports.STREET_LAYOUT_ID = 'street_layout';
var STATIC_CITIES_SOURCE_ID = exports.STATIC_CITIES_SOURCE_ID = 'static_cities_source';
var STATIC_CITIES_LAYOUT_ID = exports.STATIC_CITIES_LAYOUT_ID = 'static_cities_layout';
var STATIC_CITIES_BORDERS_LAYOUT_ID = exports.STATIC_CITIES_BORDERS_LAYOUT_ID = 'static_cities_borders_layout';

var POLYGONS_URL = exports.POLYGONS_URL = 'https://onmap-assets.s3.eu-central-1.amazonaws.com/website/polygons/neighborhoods_polygons.min.json';

var MAX_CITY_ZOOM = exports.MAX_CITY_ZOOM = 12;

var MAP_TYPES = exports.MAP_TYPES = {
  SEARCH: 'search_map',
  PROPERTY: 'property_map',
  COMPANY: 'company_map' };


var getPinsWithNumbersTypes = function getPinsWithNumbersTypes() {
  var iconTypes = {};
  var numbers = [2, 3, 4, 5, 6, 7, 8, 9, 10];
  numbers.forEach(function (num) {
    iconTypes['PROPERTY_' + num] = 'property-' + num;
    iconTypes['PROPERTY_REVIEWED_' + num] = 'property-reviewed-' + num;
    iconTypes['PROJECT_' + num] = 'project-' + num;
    iconTypes['PROJECT_REVIEWED_' + num] = 'project-reviewed-' + num;
  });

  return iconTypes;
};

var PINS_WITH_NUMBERS_TYPES = getPinsWithNumbersTypes();

var PIN_TYPES = exports.PIN_TYPES = Object.assign({
  PROPERTY: 'property',
  FAVORITE: 'favorite',
  PROJECT: 'project',
  PROPERTY_REVIEWED: 'property-reviewed',
  FAVORITE_REVIEWED: 'favorite-reviewed',
  PROJECT_REVIEWED: 'project-reviewed',
  AGENCY: 'agency' },
PINS_WITH_NUMBERS_TYPES);


var requiredMapIcons = exports.requiredMapIcons = (_requiredMapIcons = {}, _requiredMapIcons[
MAP_TYPES.PROPERTY] = [PIN_TYPES.PROPERTY], _requiredMapIcons[
MAP_TYPES.SEARCH] = [].concat(
Object.values(PIN_TYPES)), _requiredMapIcons[

MAP_TYPES.COMPANY] = [
PIN_TYPES.PROPERTY,
PIN_TYPES.FAVORITE,
PIN_TYPES.PROPERTY_REVIEWED,
PIN_TYPES.FAVORITE_REVIEWED].concat(
Object.values(PINS_WITH_NUMBERS_TYPES)), _requiredMapIcons);



var pinsLayoutConfig = exports.pinsLayoutConfig = {
  id: PINS_LAYOUT_ID,
  type: 'symbol',
  source: PINS_SOURCE_ID,
  paint: {
    'text-color': '#ffffff',
    'icon-opacity': ['feature-state', 'opacity'] },

  layout: {
    'icon-allow-overlap': true,
    'icon-image': ['get', 'icon'],
    'icon-anchor': 'bottom',
    'symbol-sort-key': ['get', 'zIndex'] } };



var cityPolygonLayoutConfig = exports.cityPolygonLayoutConfig = {
  id: CITY_POLYGON_LAYOUT_ID,
  source: CITY_POLYGON_SOURCE_ID,
  type: 'fill',
  paint: {
    'fill-opacity': 0.15,
    // 'line-width': 2,
    'fill-outline-color': '#0f86ba',
    'fill-color': '#5ebfe9' } };



var cityBorderLayoutConfig = exports.cityBorderLayoutConfig = {
  id: CITY_BORDER_LAYOUT_ID,
  source: CITY_POLYGON_SOURCE_ID,
  type: 'line',
  paint: {
    'line-width': 2,
    'line-color': '#0f86ba' } };



var streetLayoutConfig = exports.streetLayoutConfig = {
  id: STREET_LAYOUT_ID,
  source: STREET_SOURCE_ID,
  type: 'line',
  paint: {
    'line-width': 5,
    'line-opacity': 0.3,
    'line-color': '#5ebfe9' } };



var staticCitiesBordersConfigMobile = exports.staticCitiesBordersConfigMobile = {
  id: STATIC_CITIES_BORDERS_LAYOUT_ID,
  source: STATIC_CITIES_SOURCE_ID,
  type: 'line',
  paint: {
    'line-width': 1,
    'line-opacity': [
    'interpolate',
    ['linear'],
    ['zoom'],
    9,
    0,
    10,
    1],

    'line-color': '#5ebfe9' } };



var staticCitiesBordersConfig = exports.staticCitiesBordersConfig = {
  id: STATIC_CITIES_BORDERS_LAYOUT_ID,
  source: STATIC_CITIES_SOURCE_ID,
  type: 'line',
  paint: {
    'line-width': 1,
    // 'line-opacity': 1, // 0.35,
    'line-opacity': [
    'interpolate',
    ['linear'],
    ['zoom'],
    12,
    0,
    12.2,
    1],

    'line-color': '#5ebfe9' } };



var staticCitiesConfig = exports.staticCitiesConfig = {
  id: STATIC_CITIES_LAYOUT_ID,
  source: STATIC_CITIES_SOURCE_ID,
  type: 'fill',
  paint: {
    'fill-color': '#5ebfe9',
    'fill-opacity': [
    'case',
    ['boolean', ['feature-state', 'hover'], false], 0.2,
    0] } };


//////////////////
// WEBPACK FOOTER
// ./src/services/MapboxService/constants.js
// module id = 283
// module chunks = 0